import { Box, Text, Input, Textarea, Flex } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';

import {
  getSelectedPage,
  updatePage,
  getSelectedDashboardScenario,
  getCompareDashboardScenario,
  getReportingAnchorPeriod,
  getReportingWindow,
} from 'redux/DashboardSliceV2';
import { AppDispatch } from 'utils/GlobalHelpers';
import { formatReportingDisplay } from 'utils/reportingPeriodUtils';

const PageInfo = () => {
  const dispatch: AppDispatch = useDispatch();
  const selectedPage = useSelector(getSelectedPage);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedName, setEditedName] = useState('');
  const [editedDescription, setEditedDescription] = useState('');
  const selectedScenario = useSelector(getSelectedDashboardScenario);
  const compareScenario = useSelector(getCompareDashboardScenario);
  const anchorPeriod = useSelector(getReportingAnchorPeriod);
  const reportingWindow = useSelector(getReportingWindow);

  const handleNameDoubleClick = () => {
    setEditedName(selectedPage?.name || '');
    setIsEditingName(true);
  };

  const handleDescriptionDoubleClick = () => {
    setEditedDescription(selectedPage?.description || '');
    setIsEditingDescription(true);
  };

  const handleNameSave = async () => {
    if (selectedPage && editedName.trim()) {
      try {
        await dispatch(
          updatePage({
            request_body: {
              ...selectedPage,
              name: editedName.trim(),
            },
          }),
        );
      } catch {
        // Handle error if needed
      }
    }
    setIsEditingName(false);
  };

  const handleDescriptionSave = async () => {
    if (selectedPage) {
      try {
        await dispatch(
          updatePage({
            request_body: {
              ...selectedPage,
              description: editedDescription.trim(),
            },
          }),
        );
      } catch {
        // Handle error if needed
      }
    }
    setIsEditingDescription(false);
  };

  const handleNameKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleNameSave();
    } else if (event.key === 'Escape') {
      setIsEditingName(false);
    }
  };

  const handleDescriptionKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && event.ctrlKey) {
      handleDescriptionSave();
    } else if (event.key === 'Escape') {
      setIsEditingDescription(false);
    }
  };

  return (
    <>
      <Box>
        <Box>
          {isEditingName ? (
            <Input
              value={editedName}
              onChange={(event) => setEditedName(event.target.value)}
              onBlur={handleNameSave}
              onKeyDown={handleNameKeyPress}
              fontSize='xl'
              color='white'
              bg='rgba(255, 255, 255, 0.1)'
              border='1px solid rgba(255, 255, 255, 0.3)'
              _focus={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                boxShadow: 'none',
              }}
              mb={selectedPage?.description ? 1 : 2}
              autoFocus
            />
          ) : (
            <Text
              fontSize='xl'
              color='white'
              mb={1}
              cursor='pointer'
              onDoubleClick={handleNameDoubleClick}
              _hover={{ opacity: 0.8 }}
              title={selectedPage?.name || 'No name available.'}
              noOfLines={1}
            >
              {selectedPage?.name || 'No name available.'}
            </Text>
          )}
        </Box>

        {(selectedPage?.description || isEditingDescription) && (
          <Box>
            {isEditingDescription ? (
              <Textarea
                value={editedDescription}
                onChange={(event) => setEditedDescription(event.target.value)}
                onBlur={handleDescriptionSave}
                onKeyDown={handleDescriptionKeyPress}
                fontSize='md'
                color='white'
                bg='rgba(255, 255, 255, 0.1)'
                border='1px solid rgba(255, 255, 255, 0.3)'
                _focus={{
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  boxShadow: 'none',
                }}
                mb={1}
                autoFocus
                resize='vertical'
                minH='60px'
              />
            ) : (
              <Text
                fontSize='md'
                color='white'
                mb={1}
                cursor='pointer'
                onDoubleClick={handleDescriptionDoubleClick}
                _hover={{ opacity: 0.8 }}
                title={selectedPage?.description || 'Add description here'}
                noOfLines={1}
              >
                {selectedPage?.description || 'Add description here'}
              </Text>
            )}
          </Box>
        )}

        {/* {!selectedPage?.description && !isEditingDescription && (
        <Box>
          <Text
            fontSize='md'
            color='rgba(255, 255, 255, 0.6)'
            mb={1}
            cursor='pointer'
            onDoubleClick={handleDescriptionDoubleClick}
            _hover={{ opacity: 0.8 }} 
            title='Double-click to add description'
          >
            Double-click to add description...
          </Text>
        </Box>
      )} */}
      </Box>
      {/* Compact scenario + reporting period bar */}
      <Flex flexWrap='wrap' gap={1} alignItems='center'>
        <Text fontSize='12px' color='#D9D9D9' noOfLines={1}>
          {selectedScenario?.name || 'No scenario selected'}
          {compareScenario ? ` vs ${compareScenario.name}` : ''}
        </Text>
        {anchorPeriod && reportingWindow ? (
          <>
            <Text fontSize='12px' color='rgba(255,255,255,0.4)'>
              {'•'}
            </Text>
            <Text fontSize='12px' color='#D9D9D9' noOfLines={1}>
              {formatReportingDisplay(anchorPeriod, reportingWindow)}
            </Text>
          </>
        ) : null}
      </Flex>
    </>
  );
};
export default PageInfo;
